module.exports = __webpack_public_path__ + "4ce9af6bdd4b5fd32f3e0ec1e8dded03.jpg";